var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"loading":_vm.loading,"title":`Centro de custo - ${_vm.infraestrutura.nome}`,"large":"","hide-footer":""}},[_c('Form',{ref:"Form",attrs:{"infraestrutura":_vm.infraestrutura}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }